import API from '../../../helpers/request/api';

const getInfo = () => {
  const api = new API();
  const query = {
    query: `{
      current_user_info
      {
        id
        name
        email
        registration_date
        photo
        language {
          id
          slug
          name
        }
        group {
          show_content_unavailable
          progressive_post_release
        }
      }
    }`,
  };
  return api.get(query);
};

export default {
  getInfo,
};



// WEBPACK FOOTER //
// ./src/screens/Index/queries/user.js